import moment from "moment";
import { useNavigate } from "react-router-dom";

const TableWidgetTransactions = ({ data }) => {
    const navigate = useNavigate();

    const dataList = data.slice(0, 10) || [];
    const hasData = dataList && dataList.length > 0;



    return (
        <div className="card card-flush h-xl-100">
            {/* Header */}

            <div className="card-header pb-7">
                <div className="card-title pt-3 mb-0 gap-4 gap-lg-10 gap-xl-15 nav nav-tabs border-bottom-0">
                    <div className="fs-4 fw-bold pb-3">
                        Recent Transactions
                    </div>
                </div>

                <div className="card-toolbar">
                    <a
                        href="javascript:void(0)"
                        type="button"
                        className="btn btn-primary"
                        onClick={() => navigate('/all-transactions')}
                    >
                        View All
                    </a>
                </div>
            </div>

            <div className={`card-body pt-1 table-responsive tab-pane `} id="payairo-transactions" role="tabpanel" aria-labelledby="payairo-transactions-link">
                <table className="table table-row-dashed align-middle fs-6 gy-4 my-0 pb-3">
                    <thead>
                        <tr>
                            <th>Transaction ID</th>
                            <th>Amount</th>
                            <th>Sender</th>
                            <th>Receiver</th>
                            <th>Type</th>
                            <th>Status</th>
                        </tr>
                    </thead>
                    <tbody>
                        {hasData ? dataList?.map((txn, index) => (
                            <tr key={index}>
                                <td className="min-w-175px">
                                    <div className="position-relative ps-6 pe-3 py-2">
                                        <div
                                            className={`position-absolute start-0 top-0 w-4px h-100 rounded-2 bg-${txn.status === "success" ? "success" : txn.status === "Pending" ? "warning" : "danger"}`}
                                        />
                                        <a
                                            href="javascript:void(0)"
                                            className="mb-1 text-dark text-hover-primary fw-bold"
                                        >
                                            {txn.id}
                                        </a>
                                        <div className="fs-7 text-muted fw-bold">
                                            {moment(txn.created_at).format('DD MMM YYYY, hh:mm A')}
                                        </div>
                                    </div>
                                </td>

                                <td className="fw-bold text-gray-800">${txn.amount}</td>
                                <td>
                                    <div className="fw-bold">{txn.sender_username}</div>
                                    <div className="fs-7 text-muted">{txn.sender_email}</div>
                                </td>
                                <td>
                                    <div className="fw-bold">{txn.recipient_username}</div>
                                    <div className="fs-7 text-muted">{txn.recipient_email}</div>
                                </td>
                                <td>
                                    <span className={`badge badge-light-${txn.type === "User to User" ? "primary" : "info"}`}>{txn.type}</span>
                                </td>
                                <td>
                                    <span className={`badge text-capitalize badge-light-${txn.status === "success" ? "success" : txn.status === "Pending" ? "warning" : "danger"}`}>{txn.status}</span>
                                </td>
                            </tr>
                        )) :
                            <tr>
                                <td colSpan={6} className="text-center text-muted py-5">
                                    No transactions available
                                </td>
                            </tr>
                        }
                    </tbody>
                </table>
            </div>

        </div>
    );
};

export default TableWidgetTransactions;
